import { getAuthHeaders, WORKER_URL } from '../../utils/api';
const CACHE_KEY = 'shipping_next_workday';


export const ShippingCache = {
    saveCheck: (data) => {
        const cacheData = {
            lastCheckDate: new Date().toISOString().split('T')[0],
            nextWorkDay: data,
            checked: true,
            lastCheckTime: new Date().toISOString()
        };
        localStorage.setItem(CACHE_KEY, JSON.stringify(cacheData));
    },

    getData: () => {
        try {
            const cached = localStorage.getItem(CACHE_KEY);
            if (!cached) return null;
            return JSON.parse(cached);
        } catch (error) {
            console.error('Erro ao ler cache:', error);
            return null;
        }
    },

    wasCheckedToday: () => {
        const data = ShippingCache.getData();
        if (!data) return false;
        
        const today = new Date().toISOString().split('T')[0];
        return data.lastCheckDate === today && data.checked;
    },

    clear: () => {
        localStorage.removeItem(CACHE_KEY);
    }
};

export const checkDeliveryTime = (schedule) => {
    if (!schedule?.deliveryTime) return false;
    
    const now = new Date();
    const currentDay = now.getDay();
    
    // Se for sábado ou domingo, considera como depois do horário
    if (currentDay === 0 || currentDay === 6) return true;
    
    const [hours, minutes] = schedule.deliveryTime.split(':');
    const deliveryTime = new Date();
    deliveryTime.setHours(parseInt(hours), parseInt(minutes), 0);
    return now > deliveryTime;
};



export const fetchNextWorkDay = async (userId, token, logisticType) => {
    try {
        const res = await fetch(`${WORKER_URL}/api/shipping/next-workday/${logisticType}`, { headers: getAuthHeaders() });
        const response = { data: await res.json() };

        const days = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'];
        const weekDays = {
            monday: 'Segunda-feira',
            tuesday: 'Terça-feira',
            wednesday: 'Quarta-feira',
            thursday: 'Quinta-feira',
            friday: 'Sexta-feira'
        };

        // Verifica próximos 7 dias
        let checkDate = new Date();
        for (let i = 1; i <= 7; i++) {
            checkDate.setDate(checkDate.getDate() + 1);
            const dayIndex = checkDate.getDay();
            const dayName = days[dayIndex];

            // Verifica se é dia útil e tem horários
            if (response.data?.schedule?.[dayName]?.work && 
                response.data?.schedule?.[dayName]?.detail?.length) {
                const scheduleDetail = response.data.schedule[dayName].detail[0];
                
                // Se for amanhã, retorna "Amanhã"
                if (i === 1) {
                    return {
                        date: checkDate.toISOString().split('T')[0],
                        type: 'tomorrow',
                        name: 'Amanhã',
                        cutoffSales: scheduleDetail.cutoff,
                        deliveryTime: scheduleDetail.from
                    };
                }
                
                // Se não, retorna o nome do dia
                return {
                    date: checkDate.toISOString().split('T')[0],
                    type: 'weekday',
                    name: weekDays[dayName] || dayName,
                    cutoffSales: scheduleDetail.cutoff,
                    deliveryTime: scheduleDetail.from
                };
            }
        }

        return null;
    } catch (error) {
        console.error('Erro ao verificar próximo dia útil:', error);
        return null;
    }
};